import React from 'react';

export default function Chip({ className, title, children }) {
  return (
    <span className={`chip ${className}`} title={title}>{children}</span>
  );
}
